<template>
	<div>
		<v-tabs v-model="fenceTab" class="mb-2">
			<!-- <v-tab>Modele/preturi HUB EU</v-tab> -->
			<v-tab>Preturi Configurator vechi EU</v-tab>
			<v-tab>Marje regiuni EU</v-tab>
		</v-tabs>

		<v-tabs-items v-model="fenceTab">
			<!-- <v-tab-item>
				<FenceModelsEU />
			</v-tab-item> -->
			<v-tab-item>
				<ConfiguratorPricesEU />
			</v-tab-item>
			<v-tab-item>
				<FenceCountiesEU />
			</v-tab-item>
		</v-tabs-items>

	</div>
</template>

<script>
// import FenceModelsEU from './Fences/ModelsEU.vue'
import FenceCountiesEU from './Fences/CountiesEU.vue'
import ConfiguratorPricesEU from './Fences/ConfiguratorPricesEU'

export default {
	name: "SetariObiective",
	components: {
		// FenceModelsEU,
		FenceCountiesEU,
		ConfiguratorPricesEU
	},
	data() {
		return {
			fenceTab: null
		};
	},
};
</script>

<style scoped></style>
